import { Button, Box, Drawer, Divider, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CommonGrid from "../../../../Repository/CommonGrid";
import ErrorModal from "../ErrorModal";
import { useEffect } from "react";
import Split from "react-split";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import DataValidationCustomizeScreen from "./DataValidationCustomizeScreen";

const drawerWidth = 450;
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create(["margin", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    margin: 0,
    marginLeft: 0, // Initially no margin
    padding: 0,
    ...(open && {
      transition: theme.transitions.create(["marginLeft", "padding"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: drawerWidth, // Set marginLeft to drawerWidth when open
    }),
  })
);
function QuickAddNewValues(props) {
  const { openModal, toggle, action, keyValuePairs } = props;
  const { t } = useTranslation();
  const titleContains = t("DIAG_QUICK_CODESET_ADD_DESC").split("\\n").join("");
  const titleDateConatins = t("DIAG_QUICK_BY_PASS_VALIDATION_ADD_DESC")
    .split("\\n")
    .join("");
  const initialRowData = { id: 0, VALUE: "", DESCRIPTION: "" };
  const [gridApi, setGridApi] = useState();
  const [deletedKeys, setDeletedKeys] = useState([]);
  const [rowData, setRowData] = useState([initialRowData]);
  const [errorModal, setErrorModal] = useState(false);
  const [openCustomizeDialog, setOpenCustomizeDialog] = useState(false);
  const [recordDelimiterWhilePasting, setRecordDelimiterWhilePasting] =
    useState("");
  const [fieldDelimiterWhilePasting, setFieldDelimiterWhilePasting] =
    useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedRowId, setSelectedRowId] = useState([])
  const gridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        lockPosition: true,
        deleteHandler: (data) => {
          if (data?.initialData) {
            setDeletedKeys((prev) => [...prev, data]);
          }
        },
        showDeleteIcon: (data) => {
          return data.VALUE || data.DESCRIPTION;
        },
        headerClass: "first-column-header",
      },
      {
        headerName: t("COL_VAL"),
        field: "VALUE",
        editable: true,
        resizable: true,
        showPlaceholder: true,
        placeholder: t("BTN_NEW_VALUE"),
      },
      {
        headerName: t("LBL_DESC"),
        field: "DESCRIPTION",
        editable: true,
        resizable: true,
        showPlaceholder: true,
        placeholder: t("DESCRIPTION"),
      },
    ],
    onRowClicked: function (event) {
      event.node.setSelected(false); // Unselects the row on click
    },
    rowSelection: "multiple",
  };

  const getGridAPI = (api) => {
    setGridApi(api);
  };

  const checkUniqueValue = (rowData, keyValuePairs) => {
    const duplicates = [];
    
    for (let i = 0; i < keyValuePairs.length; i++) {
      const pair = keyValuePairs[i];
      
      const foundDuplicate = rowData.find(row => row.VALUE === pair.VALUE);
      
      if (foundDuplicate) {
        duplicates.push(foundDuplicate.id);
      }
    }
  
    return duplicates.length ? duplicates : false;
  };

  const hasDuplicateValuesinGrid = (data) => {
    const valueToIdsMap = new Map();  
    const duplicateIds = new Set();   
  
    for (const item of data) {
      if (item.VALUE) {
        if (valueToIdsMap.has(item.VALUE)) {
          duplicateIds.add(item.id);
          valueToIdsMap.get(item.VALUE).forEach(id => duplicateIds.add(id));
        } else {
          valueToIdsMap.set(item.VALUE, [item.id]);
        }
        valueToIdsMap.get(item.VALUE).push(item.id);
      }
    }
    return duplicateIds.size ? Array.from(duplicateIds) : false;  // Return all duplicate IDs or false if none
  };
  
  const setSelectedRow = (idsArray) => {
    gridApi.forEachNode((node) => {
      if (idsArray.includes(node.data.id)) {
        node.setSelected(true);  // Select the node if its ID is a duplicate
      } else {
        node.setSelected(false);  
      }
    });
  }
  const findSelectedRows = (rowData = []) => {
    const isDuplicateFound = hasDuplicateValuesinGrid(rowData)
    const isDuplicateInExistingRangeValue = checkUniqueValue(rowData,keyValuePairs);
    let combinedDuplicates = [];

    if (isDuplicateFound && isDuplicateFound.length > 0) {
       combinedDuplicates = [...isDuplicateFound];
    }

    if (isDuplicateInExistingRangeValue && isDuplicateInExistingRangeValue.length > 0) {
      combinedDuplicates = [...combinedDuplicates, ...isDuplicateInExistingRangeValue];
    }
    
    if (combinedDuplicates.length > 0) {
      setErrorModal(true);
      setErrorMessage(`${t('BOX_ERR_CANNOT_ADD_DUPS').split('.')[0]}.`);
      setSelectedRowId(combinedDuplicates);  
      return false;
    }
    return true;
  }
  const handleCellValueChanged = (gridOptions) => {
    const colId = gridOptions.column.colId;
    const rowData = [];
    gridOptions.api.forEachNode((node) => rowData.push(node.data));

    if (colId === "VALUE") {
      const isDuplicateFound = hasDuplicateValuesinGrid(rowData)
      const isDuplicateInExistingRangeValue = checkUniqueValue(rowData,keyValuePairs);


      if ( isDuplicateFound.length > 0 || isDuplicateInExistingRangeValue.length > 0 ) {
          findSelectedRows(rowData);
      }

    }
  };
  const handleAddClick = (e) => {
    if (!gridApi) {
      console.error("Grid API is not initialized.");
      return;
    }
    // get data on grid
    const rowData = [];
    gridApi.forEachNode((node) => rowData.push(node.data));

   
    // check if rowData has description but no value
    const isDescriptionOnly = (rowData) => {
      for (const item of rowData) {
        if (
          (item.VALUE === "" ||
            item.VALUE === undefined ||
            !item.hasOwnProperty("VALUE")) &&
          item.DESCRIPTION
        ) {
          return true;
        }
      }
      return false;
    };
    // show error modal if condition is true
    if (rowData.length > 1) {
       if(!findSelectedRows(rowData)) return;

      if (isDescriptionOnly(rowData)) {
        setErrorModal(true);
        setErrorMessage(`${t("BOX_VALUE_IS_REQUIRED").split(".")[0]}.`);
        return;
      }
    }
    
    // if everything went well add data to data validation table
      const reqArray = rowData
        .filter((row) => row.VALUE || row.DESCRIPTION)
        .map((row) => {
          return { VALUE: row.VALUE, DESCRIPTION: row.DESCRIPTION || "" };
        });
      props.handleQuickAddInput(reqArray);
  };

  const closeCustomizeModal = (e) => {
    setOpenCustomizeDialog(e);
  };
  const handleDelimiterValues = ({ recordDelimiter, fieldDelimiter }) => {
    setRecordDelimiterWhilePasting(recordDelimiter);
    setFieldDelimiterWhilePasting(fieldDelimiter);
  };

  const handleCancelClick = () => toggle();
  
  const handleBackdropClick = (event, reason) => {
    // Prevent closing the drawer when the backdrop is clicked
    if (reason === "backdropClick") return;
  };

  useEffect(() => {
    setRowData([initialRowData]);
  }, [openModal]);

  useEffect(() => {
    if(selectedRowId.length) setSelectedRow(selectedRowId)
  },[selectedRowId])

  return (
    <>
      <Drawer 
       anchor={"left"} 
       open={openModal} 
       ModalProps={{
        onBackdropClick: handleBackdropClick,
      }}
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "100%",
          boxShadow:'none',
          backgroundColor:'transparent'
        },
      }}
       onClose={handleCancelClick}>
        <Main open={openCustomizeDialog}>
          <Split
            className="split height-100 flex"
            direction="horizontal"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
            minSize={[550, 0]}
            sizes={[67, 33]}
            children={[<div className="flex-column height-100 width-100" key="main" style={{backgroundColor:'white',position:'relative'}}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "1rem",
                }}>
                <div style={{ lineHeight: "25px" }}>
                  <p style={{ marginBottom: "10px" }}>
                    {action === "CONTAINS" && t("DIAG_QUICK_CODESET_ADD_TIT")}
                    {action === "DATE_CONTAINS" &&
                      t("DIAG_QUICK_BY_PASS_VALIDATION_ADD_TIT")}
                  </p>
                  <p className="font-12">
                    {action === "CONTAINS" && titleContains}
                    {action === "DATE_CONTAINS" && titleDateConatins}
                  </p>
                </div>
                <div>
                  <IconButton
                    onClick={handleCancelClick}
                    sx={{ borderRadius: "5px" }}>
                    <CloseIcon
                      sx={{
                        height: "28px",
                        width: "28px",
                        color: "#777777",
                      }}
                    />
                  </IconButton>
                </div>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "12px",
                  gap:'10px'
                }}>
                <Button
                  variant="outlined"
                  onClick={() => setOpenCustomizeDialog(true)}
                  color="primary"
                  size="small">
                  Customize Quick Add
                </Button>
              </div>
              <Box style={{ height: "100%", padding: "12px" }}>
                <CommonGrid
                  showContextMenu={true}
                  contextMenuId="data-validation-quick-add"
                  fieldDelimeter={fieldDelimiterWhilePasting}
                  delimeter={recordDelimiterWhilePasting}
                  rowData={rowData}
                  enableAutoBlur={false}
                  gridOptions={gridOptions}
                  getGridAPI={getGridAPI}
                  gridProps={{
                    animateRows: false,
                    ensureDomOrder: true,
                    singleClickEdit: true,
                    suppressScrollWhenPopupsAreOpen: true,
                    enableCellTextSelection: true,
                    onCellValueChanged: handleCellValueChanged,
                  }}
                  containerStyle={{
                    height: "100%",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  padding: "12px",
                }}>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleAddClick}>
                  {t("DB_NAV_ADD")}
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleCancelClick}>
                  {t("CANCEL")}
                </Button>
              </Box>
            </div>]}>
           
          </Split>
        </Main>
      </Drawer>
      {errorModal && (
        <ErrorModal
          errorModal={errorModal}
          errorMessage={errorMessage}
          handleErrorModal={() => setErrorModal(false)}
        />
      )}
      {openCustomizeDialog && (
        <DataValidationCustomizeScreen
          open={openCustomizeDialog}
          setOpenCustomizeModal={closeCustomizeModal}
          setDelimiterValue={handleDelimiterValues}
        />
      )}
    </>
  );
}

export default QuickAddNewValues;
